
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class MbReport_01_Dt_Dialog extends Serenity.Extensions.GridEditorDialog<MbReport_01_Dt_Row> {
        protected getFormKey() { return MbReport_01_Dt_Form.formKey; }
        // protected getIdProperty() { return MbReport_01_Dt_Row.idProperty; }
        protected getLocalTextPrefix() { return MbReport_01_Dt_Row.localTextPrefix; }
        protected getNameProperty() { return MbReport_01_Dt_Row.nameProperty; }
        // protected getService() { return MbReport_01_Dt_Service.baseUrl; }
        // protected getDeletePermission() { return MbReport_01_Dt_Row.deletePermission; }
        // protected getInsertPermission() { return MbReport_01_Dt_Row.insertPermission; }
        // protected getUpdatePermission() { return MbReport_01_Dt_Row.updatePermission; }

        protected form = new MbReport_01_Dt_Form(this.idPrefix);

    }
}